import { render } from "./PotentialLossTd.vue?vue&type=template&id=10d0872c"
import script from "./PotentialLossTd.vue?vue&type=script&lang=js"
export * from "./PotentialLossTd.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__